export const props = Object.freeze({
  /**
   * URL to POST the preview request to. The endpoint starts the comparison
   * against the canonical source in the background and returns a preview token.
   * @type {String}
   */
  previewUrl: {
    type: String,
    required: true,
  },
  /**
   * URL to GET the preview status from, with the preview token as a `token`
   * query param. Returns the review rows once the comparison is ready.
   * @type {String}
   */
  statusUrl: {
    type: String,
    required: true,
  },
  /**
   * URL to POST the confirmed update to, with the preview token in the body;
   * the server queues the apply.
   * @type {String}
   */
  processUrl: {
    type: String,
    required: true,
  },
  /**
   * Title for the modal.
   * @type {String}
   */
  modalTitle: {
    type: String,
    default: "Update from Canonical",
  },
  /**
   * JSON object of `{new, updated, removed, skipped, unchanged}` tooltip strings
   * for the review's row status icons (server passes localized text). English
   * defaults apply when omitted. Error rows show the joined row errors instead.
   * @type {String}
   */
  statusLabels: {
    type: String,
    default: "",
  },
  /**
   * JSON object of localized UI copy, always passed by the helper. Deep-merged
   * over minimal English defaults in the store. Shape (camelCase keys):
   * `{confirm, cancel, loading, emptyState, rejectedNote, removedValue,
   * columns: {status, name, type, changes},
   * attributes: {<attribute>: <label>, ...},
   * summary: {new, updated, removed, skipped, unchanged, errors},
   * errors: {previewFailed, processFailed}, flash: {queued}}`
   * — the summary values are `{one, other}` templates with a literal
   * `%{count}` placeholder; `removedValue` uses `%{name}`.
   * @type {String}
   */
  labels: {
    type: String,
    default: "{}",
  },
});
